import React from 'react';

import useAdditionalGroupsCart from 'modules/cart/util/use-additional-groups-cart';
import {AdditionalPriceWhenFree} from 'modules/products/types';
import Column from 'shared/components/column';
import Row from 'shared/components/row';
import {MediumText, RegularText} from 'shared/components/text';

interface Props extends AdditionalProps {
  additionalGroupConfigId: string;
  productId: string;
  isFree: boolean;
  disabled: boolean;
  additionalPricesWhenFree: AdditionalPriceWhenFree[];
}

const MultiAdditional: React.FC<Props> = ({
  id,
  name,
  description,
  productId,
  additionalGroupConfigId,
  isFree,
  disabled,
  additionalPricesWhenFree,
  ...props
}) => {
  const {colors} = useTheme();
  const {getAdditionalGroupCart, addAdditional, removeAdditional} =
    useAdditionalGroupsCart(productId);

  const additionalsDraft = getAdditionalGroupCart(additionalGroupConfigId);
  const additional = additionalsDraft?.find(
    (additional) => additional.id === id,
  );

  const handleAddAdditional = () => addAdditional(additionalGroupConfigId, id);

  const handleRemoveAdditional = () =>
    removeAdditional(additionalGroupConfigId, id);

  const chargeWhenFreePrice = additionalPricesWhenFree?.find(
    (additional) => additional.id === id,
  )?.price;

  const price = !isFree ? props.price : chargeWhenFreePrice;

  return (
    <Container onClick={handleAddAdditional} {...{disabled}}>
      <Row justifyContent="space-between" style={{flex: 1}}>
        <Column style={{maxWidth: '70%'}}>
          <MediumText size="small">{name}</MediumText>
          {description && <RegularText size="small">{description}</RegularText>}
        </Column>
        <Row style={{gap: 5}}>
          {additional && (
            <Pressable
              onClick={(e) => {
                e.stopPropagation();
                handleRemoveAdditional();
              }}>
              <IoRemove color={colors.primary} size={22} />
            </Pressable>
          )}
          {additional && (
            <RegularText style={{marginTop: -4}}>
              {additional.quantity}
            </RegularText>
          )}
          <Pressable onClick={handleAddAdditional} {...{disabled}}>
            <IoAdd color={colors.primary} size={22} />
          </Pressable>
        </Row>
      </Row>
      {price ? <RegularText size="small">+ {toBrl(price)}</RegularText> : null}
    </Container>
  );
};

export default MultiAdditional;

import styled, {useTheme} from 'styled-components';
import {IoIosAdd} from 'react-icons/io';
import {AdditionalProps} from 'modules/additionals/types';
import Pressable from 'shared/components/pressable';
import toBrl from 'shared/util/to-brl';
import {IoAdd, IoRemove} from 'react-icons/io5';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  padding: 5px 15px;
  border-bottom: 1px solid rgba(128, 128, 128, 0.4);
  background-color: white;

  border: none;
  cursor: pointer;
`;

export const Icon = styled(IoIosAdd)`
  font-size: 22px;
  color: ${(props) => props.theme.colors.primary};
`;
